module.exports = __webpack_public_path__ + "img/D201312_1.369094eb.jpg";